export const recipeCategories = [
  "Indian",
  "Chinese",
  "Italian",
  "Mexican",
  "Thai",
  "Japanese",
  "Korean",
  "French",
  "Mediterranean",
  "Middle Eastern",
  "American",
  "British",
  "German",
  "Spanish",
  "Greek",
  "Turkish",
  "Lebanese",
  "Vietnamese",
  "Continental",
  "Moroccan",
  "Brazilian",
  "Peruvian",
  "Argentinian",
  "Ethiopian",
  "Russian",
  "Scandinavian",
  "Caribbean",
  "Fusion",
  "Other",
];
export const recipeTypes = ["Veg", "Non-Veg"];
export const servings = [1, 2, 3, 4, 5, 6, 7, 8];
export const powder_spices = [
  "Salt",
  "Chilly Powder",
  "Turmeric Powder",
  "Coriander Powder",
  "Cumin Powder",
  "Garam Masala",
  "Amchur Powder",
  "Asafoetida",
  "Black Pepper Powder",
  "Cardamom Powder",
  "Clove Powder",
  "Cinnamon Powder",
  "Nutmeg Powder",
  "Fenugreek Powder",
  "Ginger Powder",
  "Garlic Powder",
  "Onion Powder",
  "Mustard Powder",
  "Pomegranate Seed Powder",
  "Mango Powder",
  "Ajwain Powder",
  "Bay Leaf Powder",
  "Star Anise Powder",
  "Celery Powder",
  "Tamarind Powder",
  "Curry Leaf Powder",
  "Sambar Powder",
  "Rasam Powder",
  "Biryani Masala",
  "Pav Bhaji Masala",
  "Chaat Masala",
  "Tandoori Masala",
  "Kitchen King Masala",
  "Dal Makhani Masala",
  "Kebab Masala",
  "Fish Curry Masala",
  "Chicken Curry Masala",
  "Meat Masala",
  "Egg Curry Masala",
  "Paneer Tikka Masala",
  "Veg Curry Masala",
  "Fennel Powder",
  "Basil Powder",
  "Oregano Powder",
  "Thyme Powder",
  "Rosemary Powder",
  "Parsley Powder",
  "Dill Powder",
  "Mint Powder",
  "Wasabi Powder",
  "Paprika",
  "Cayenne Pepper",
  "Kashmiri Red Chilli Powder",
  "Smoked Paprika",
  "Sweet Paprika",
  "Rose Petal Powder",
  "Tulsi Powder",
  "Mace Powder",
  "Dried Mango Powder",
  "Black Salt",
  "Rock Salt",
  "Lemon Pepper",
  "Shichimi Togarashi",
  "Za'atar",
  "Sumac",
  "Berbere",
  "Harissa",
  "Ras el Hanout",
  "Advieh",
  "Tabil",
  "Khmeli Suneli",
  "Urfa Biber",
  "Aleppo Pepper",
  "Sichuan Pepper",
  "Five-Spice Powder",
  "Cajun Seasoning",
  "Creole Seasoning",
  "Old Bay Seasoning",
  "Taco Seasoning",
  "Chimichurri Spice",
  "Peri Peri Spice",
  "Jerk Seasoning",
  "Chili Seasoning",
  "Dry Rub Spice",
  "Italian Seasoning",
  "Fajita Seasoning",
  "Adobo Seasoning",
  "Mole Spice",
  "Garlic Pepper",
  "Lemon Herb Spice",
  "Piri Piri Powder",
  "Herbes de Provence",
  "Beetroot Powder",
  "Spinach Powder",
  "Carrot Powder",
  "Tomato Powder",
  "Chives Powder",
  "Tarragon Powder",
  "Lovage Powder",
  "Saffron",
  "Vanilla Powder",
  "Cocoa Powder",
  "Chocolate Spice",
  "Coconut Powder",
  "Lotus Seed Powder",
  "Poppy Seed Powder",
  "Nigella Seed Powder",
  "Sesame Powder",
  "Watermelon Seed Powder",
  "Pumpkin Seed Powder",
  "Flaxseed Powder",
  "Chia Seed Powder",
  "Sunflower Seed Powder",
  "Melon Seed Powder",
  "Almond Powder",
  "Cashew Nut Powder",
  "Walnut Powder",
  "Hazelnut Powder",
  "Pistachio Powder",
  "Peanut Powder",
  "Gingerbread Spice",
  "Christmas Spice",
  "Pumpkin Pie Spice",
  "Clove & Nutmeg Mix",
  "Bay Leaf & Cinnamon Mix",
  "Rose Petal & Cardamom Mix",
  "Moringa Leaf Powder",
  "Spinach Leaf Powder",
  "Kale Leaf Powder",
  "Drumstick Leaf Powder",
  "Neem Leaf Powder",
];

export const grains = [
  "Wheat",
  "Rice",
  "Barley",
  "Corn",
  "Oats",
  "Millet",
  "Sorghum",
  "Quinoa",
  "Buckwheat",
  "Spelt",
  "Amaranth",
  "Teff",
  "Farro",
  "Freekeh",
  "Emmer",
  "Triticale",
  "Kamut",
  "Rye",
  "Pearl Millet",
  "Foxtail Millet",
  "Finger Millet",
  "Broomcorn Millet",
  "Japanese Millet",
  "Wild Rice",
  "Job's Tears",
  "Bulgur",
  "Semolina",
  "Grits",
  "Polenta",
  "Popcorn",
  "Hominy",
  "Red Rice",
  "Black Rice",
  "Brown Rice",
  "Sticky Rice",
  "Jasmine Rice",
  "Basmati Rice",
  "Arborio Rice",
  "Carnaroli Rice",
  "Baldo Rice",
  "Paella Rice",
  "Pudding Rice",
  "Wild Barley",
  "Hulled Barley",
  "Pearled Barley",
  "Sprouted Grains",
  "Rolled Oats",
  "Steel-Cut Oats",
  "Quick Oats",
  "Groats",
  "Farina",
  "Couscous",
  "Fonio",
  "Chia Seeds",
  "Flax Seeds",
  "Hemp Seeds",
  "Pumpkin Seeds",
  "Sunflower Seeds",
  "Sesame Seeds",
  "Canary Seeds",
  "Tricolor Quinoa",
  "Red Quinoa",
  "Black Quinoa",
  "White Quinoa",
  "Rice Bran",
  "Wheat Bran",
  "Rye Bran",
  "Corn Bran",
  "Oat Bran",
  "Barley Bran",
  "Sorghum Bran",
  "Millet Bran",
  "Buckwheat Groats",
  "Kasha",
  "Germinated Brown Rice",
  "Rice Grits",
  "Broken Rice",
  "Puffed Rice",
  "Puffed Wheat",
  "Granola",
  "Muesli",
  "Bircher",
  "Sprouted Wheat",
  "Sprouted Rye",
];
